"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "var(--sds--ursa-icons--background-color, transparent)",
  d: "M6 8a4 4 0 0 1 4-4h2.6a5 5 0 0 1 5 5v5.849a5 5 0 0 1-5 5H11a5 5 0 0 1-5-5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.07 6.928C6.07 4.692 8.057 3 10.35 3c2.295 0 4.282 1.692 4.282 3.928v7.839c0 .666-.226 1.306-.674 1.785-.454.485-1.097.764-1.842.766-.75.003-1.397-.274-1.852-.762-.448-.481-.67-1.123-.67-1.79V7.39a.7.7 0 0 1 1.4 0v7.378c0 .359.118.645.294.835.17.182.434.318.822.316.386 0 .653-.138.825-.322.179-.191.297-.476.297-.83V6.929c0-1.33-1.22-2.528-2.882-2.528C8.69 4.4 7.47 5.598 7.47 6.928v8.76c0 2.08 1.943 3.912 4.53 3.912s4.53-1.832 4.53-3.911v-8.3a.7.7 0 1 1 1.4 0v8.3C17.93 18.702 15.19 21 12 21s-5.93-2.298-5.93-5.311z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AttachFileIcon24.js.map